import { useState, useCallback } from 'react';

export const useFlash = () => {
  const [flash, setFlash] = useState(false);
  const [flashType, setFlashType] = useState('');
  const [flashMessage, setFlashMessage] = useState('');

  const handleFlash = useCallback(
    (flash: boolean, type: string, message: string) => {
      setFlash(flash);
      setFlashType(type);
      setFlashMessage(message);
    },
    []
  );

  return {
    flash,
    flashType,
    flashMessage,
    handleFlash,
  };
};
